/**
 * Curated blocklist of common disposable / temporary email providers.
 *
 * This mirrors the `disposable_email_domains` table in the database. The DB has
 * a BEFORE INSERT trigger on auth.users that is the AUTHORITATIVE gate (can't be
 * bypassed); this client-side copy just gives instant, friendly feedback in the
 * signup form. Keep the two lists roughly in sync when adding providers.
 */
export const DISPOSABLE_EMAIL_DOMAINS = new Set([
  'mailinator.com', 'mailinator.net', 'guerrillamail.com', 'guerrillamail.net',
  'guerrillamail.org', 'guerrillamail.info', 'guerrillamail.biz', 'guerrillamail.de',
  'guerrillamailblock.com', 'sharklasers.com', 'grr.la', 'spam4.me',
  '10minutemail.com', '10minutemail.net', '20minutemail.com', 'temp-mail.org',
  'temp-mail.io', 'tempmail.com', 'tempmail.net', 'tempmail.plus', 'tempmailo.com',
  'tempmailaddress.com', 'tempr.email', 'tempinbox.com', 'tempail.com',
  'tmpmail.org', 'tmpmail.net', 'throwawaymail.com', 'yopmail.com', 'yopmail.net',
  'yopmail.fr', 'getnada.com', 'nada.email', 'maildrop.cc', 'dispostable.com',
  'trashmail.com', 'trashmail.de', 'trashmail.net', 'mailnesia.com', 'mytemp.email',
  'moakt.com', 'moakt.cc', 'mohmal.com', 'fakeinbox.com', 'fakemailgenerator.com',
  'fakemail.net', 'mailcatch.com', 'spamgourmet.com', 'emailondeck.com',
  'minuteinbox.com', 'mailtemp.net', 'burnermail.io', 'luxusmail.org',
  'inboxkitten.com', 'harakirimail.com', 'dropmail.me', 'mailsac.com',
  'discard.email', 'discardmail.com', 'spambog.com', 'jetable.org', 'mintemail.com',
  'mytrashmail.com', 'tempemail.net', 'wegwerfmail.de', 'wegwerfmail.net',
  'vomoto.com', '33mail.com', 'anonbox.net', 'deadaddress.com', 'e4ward.com',
  'mailnull.com', 'spamhole.com', 'nowmymail.com', 'emailfake.com', 'email-fake.com',
  'mail7.io', 'mail.tm', '1secmail.com', '1secmail.net', '1secmail.org',
  'cs.email', 'tmails.net', 'gettempmail.com',
]);

/** Basic RFC-ish email format check (not exhaustive, just catches obvious junk). */
export function isValidEmailFormat(email) {
  if (typeof email !== 'string') return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

/** True if the email's domain is a known disposable provider. */
export function isDisposableEmail(email) {
  if (typeof email !== 'string' || !email.includes('@')) return false;
  const domain = email.split('@').pop().trim().toLowerCase();
  return DISPOSABLE_EMAIL_DOMAINS.has(domain);
}
